var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_ic",
    transform: "translate(-12 -6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9199",
    "data-name": "Rectangle 9199",
    width: 40,
    height: 40,
    rx: 13,
    transform: "translate(12 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger_icon",
    transform: "translate(22.5 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_111",
    "data-name": "Line 111",
    d: "M0,0H18.119",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#003c60",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_112",
    "data-name": "Line 112",
    d: "M0,0H18.119",
    transform: "translate(0.5 5.642)",
    fill: "none",
    stroke: "#003c60",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_113",
    "data-name": "Line 113",
    d: "M0,0H9.06",
    transform: "translate(0.5 10.784)",
    fill: "none",
    stroke: "#003c60",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIc);
export default __webpack_public_path__ + "static/media/menu_ic.48ce839d199be89ab950b7a276e70bf4.svg";
export { ForwardRef as ReactComponent };